module.exports = __webpack_public_path__ + "img/logo.731efcc5.jpg";